import _kebabCase from 'lodash/kebabCase';
import { Pixall } from '../analytics/index.js';
export function shoppingAssistantIconClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    dataLayer = {}
  } = metadata;
  Pixall.sendClickEvent({
    pageType: 'vlp',
    eventSource: 'personalization',
    label: 'icon::shopping-assistant'
  }, dataLayer, option);
  return {};
}
export function shoppingAssistantCTAClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const {
    input = '',
    isKbb = false
  } = data;
  Pixall.sendClickEvent({
    pageType: 'vlp',
    eventSource: 'personalization',
    label: isKbb ? 'icon::shopping-assistant' : `shopping-assistant::${_kebabCase(input)}`
  }, dataLayer, option);
  return {};
}
export default {
  shoppingAssistantIconClick,
  shoppingAssistantCTAClick
};